// extracted by mini-css-extract-plugin
export default {"container":"YL9-T","qrCodeImage":"HVEct","zoomed":"_3s5i-","label":"GnN-T","skeleton-progress":"_6dcU2"};